import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {CircleButtonComponent} from '../buttons/circle-button.component';
import {NgClass, NgForOf, NgIf, NgTemplateOutlet} from '@angular/common';
import {Router} from '@angular/router';
import {SmallActionButtonComponent} from '../buttons/small-action-button.component';
import {ViewportService} from '../../services/viewport-service';
import { Location } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import {AttrValues, MenuItem, MenuItemAttribute, MenuItemOption, MenuPackageChoice, MenuPackageItem, PackagePart, PackagePick, PostActions, PushPage} from '../../models/FSMenu';
import {PlusMinusButtonComponent} from '../buttons/plus-minus-button.component';
import {FormsModule} from '@angular/forms';
import {TranslateService} from '../../services/translate.service';
import MoneyUtils, {MenuUtils} from '../../utils/Utils';
import {Order, OrderItem} from '../../models/Order';
import {OrderService} from '../../services/order.service';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {SeparatorComponent} from '../ui/separator.component';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {LinkButtonComponent} from '../buttons/link-button.component';
import {CheckboxLabelComponent} from '../ui/checkbox-label.component';
import {OptionContentComponent} from '../ui/option-content.component';
import {GiftcardPersonalizedFormData} from '../ui/giftcard-personalized-form.component';
import {AppStateService} from '../../services/app-state.service';
import {isKitchenOpen} from '../../models/FSConfig';
import {PlusMinusMicroButtonComponent} from '../buttons/plus-minus-micro-button.component';
import {SnackbarService} from '../../services/snackbar.service';
import { MenuService } from '../../services/menu.service';
import {switchMap} from 'rxjs';

@Component({
  selector: 'app-item-detail',
  standalone: true,
  imports: [
    ActionButtonComponent,
    CircleButtonComponent,
    NgForOf,
    SmallActionButtonComponent,
    NgIf,
    PlusMinusButtonComponent,
    FormsModule,
    LoadingSpinnerComponent,
    SeparatorComponent,
    NgClass,
    LinkButtonComponent,
    CheckboxLabelComponent,
    OptionContentComponent,
    NgTemplateOutlet,
    PlusMinusMicroButtonComponent
  ],
  templateUrl: './item-detail.component.html',
  styleUrl: './item-detail.component.css',
  // animations: [
  //   trigger('fadeIn', [
  //     transition(':enter', [
  //       style({ opacity: 0 }),
  //       animate('300ms ease-in', style({ opacity: 1 }))
  //     ])
  //   ]),
  //   trigger('slideIn', [
  //     transition(':enter', [
  //       style({ transform: 'translateY(100%)' }),
  //       animate('300ms ease-out', style({ transform: 'translateY(0)' }))
  //     ])
  //   ])
  // ]
})
export class ItemDetailComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() item!: MenuItem;
  // "add", "display" (read-only), "edit": change the selection of `editItem`, a package in the cart, or
  // "pick": choose a package's options for a push page and hand them to `pick` instead of adding
  @Input() mode: string|undefined = "add";
  @Input() editItem?: OrderItem;
  @Input() pick?: PackagePick;
  @Output() onClose = new EventEmitter<MouseEvent>();
  attrValues: AttrValues = {};
  orderItem?: OrderItem;
  outOfStock: boolean = false;
  hasPostAction: boolean = false;
  isWorking = false;
  itemCount: number = 1;
  canEditCount: boolean = false;
  tweaksOpen = false;
  showTweak = false;
  readableWhen?: string;
  kitchenOpen?: boolean = true;
  venueOpen: boolean = true;
  prepTime?: number;
  // The open count popover of a multi attribute or a package choice: scope|attribute|option
  visKey: string | undefined;
  blockUI = false;
  isExpanded = false;

  // Package being ordered: picks per choice (option id -> count) and the resulting parts with their own attributes
  pkgCounts: Record<string, number>[] = [];
  pkgParts: PackagePart[] = [];
  pkgFixedViews: PackagePartView[] = [];
  pkgChoiceViews: PackagePartView[][] = [];
  private pkgPartValues: Record<string, AttrValues> = {};

  selCons: Record<string, any> = {};
  selAdjs: Record<string, any> = {};
  private postActionData: any;

  constructor(private router: Router, private viewportService: ViewportService, private location: Location,
              private translate: TranslateService, private orderService: OrderService,
              private sheetService: BottomSheetService, private app: AppStateService,
              private snackbar: SnackbarService, private menuService: MenuService) {
  }

  private isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  ngAfterViewInit() {
  }

  ngOnInit(): void {
    console.log("ItemDetailComponent.ngOnInit", this.item);
    if (this.mode === 'display') {
      this.setupDisplayMode();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("ItemDetailComponent.ngOnChanges", changes);
    if (changes['item']) {
      this.initializeItemData();
    }
  }

  private setupDisplayMode(): void {
    this.canEditCount = false;
    this.attrValues = {};
  }

  private initializeItemData() {
    if (this.mode === 'display') {
      return;
    }
    const startId = this.mode === 'edit' ? this.editItem?.id : this.mode === 'pick' ? this.pick?.startId : undefined;
    if (startId) {
      // Start from what the guest ordered, or picked before
      const sel = MenuUtils.decodeItemSelection(this.item, startId, id => this.lookupMenuItem(id));
      this.attrValues = sel.attrValues;
      this.setupPackage(sel.pkgCounts, sel.partValues);
    } else {
      this.attrValues = MenuUtils.defaultAttributeValues(this.item.attributes);
      this.setupPackage();
    }
    const hasPushAndIsFood = this.item.pushes && this.item.form === "f";
    this.canEditCount = !hasPushAndIsFood && this.item.post_actions == null && this.mode === "add";

    const hasAdjusts = this.item.adjusts?.length > 0;
    this.showTweak = hasAdjusts || (this.item.contains?.length > 0);
    const canBeTweaked = hasAdjusts || (this.item.contains?.filter(con => con.del)?.length > 0);

    const appState = this.app.snapshot!;
    if (appState.order?.user_cfg?.when_tag != null) {
      this.readableWhen = MenuUtils.readableWhenDeadline(this.item);
    }

    this.venueOpen = MenuUtils.isDeliverTypeOpen(appState.order.user_cfg.dt, appState.cfg);

    if (this.item.form === "f") {
      this.kitchenOpen = isKitchenOpen(appState.cfg);

      // Should we show item cooking time?
      const dt = MenuUtils.getDeliverTypeConfig(appState.order.user_cfg.dt, appState.cfg);
      if (dt) {
        if (dt.show_time) {
          this.prepTime = dt.prep_time;
          console.log("dt.prep_time",dt.prep_time);
        }
      }
    }
  }

  private setupPackage(counts?: Record<string, number>[], partValues?: Record<string, AttrValues>) {
    this.pkgCounts = counts ?? (this.item.package?.choices ?? []).map(() => ({}));
    this.pkgPartValues = partValues ?? {};
    this.updatePackageParts();
  }

  private lookupMenuItem(id: string): MenuItem | null {
    const menu = this.menuService.getMenuStructure();
    return menu ? MenuUtils.getItemInMenu(id, menu) : null;
  }

  private updatePackageParts() {
    if (this.item.package == null) {
      this.pkgParts = [];
      this.pkgFixedViews = [];
      this.pkgChoiceViews = [];
      return;
    }
    this.pkgParts = MenuUtils.packageParts(this.item.package, this.pkgCounts, id => this.lookupMenuItem(id));
    this.pkgFixedViews = [];
    this.pkgChoiceViews = this.pkgCounts.map(() => []);
    const seen: Record<string, number> = {};
    for (const part of this.pkgParts) {
      part.attrValues = this.pkgPartValues[part.key] ??= MenuUtils.defaultAttributeValues(part.menuItem?.attributes, true);
      const attributes = part.menuItem?.attributes?.filter(atr => atr.hidden !== true) ?? [];
      if (attributes.length === 0) continue;
      // A repeated pick is numbered so the guest can tell the copies apart
      const seenKey = `${part.choiceIndex}|${part.id}`;
      const n = seen[seenKey] = (seen[seenKey] ?? 0) + 1;
      const count = this.pkgParts.filter(p => p.id === part.id && p.choiceIndex === part.choiceIndex).length;
      const view = {part, attributes, label: count > 1 ? `${part.name} ${n}` : part.name};
      if (part.choiceIndex == null) {
        this.pkgFixedViews.push(view);
      } else {
        this.pkgChoiceViews[part.choiceIndex].push(view);
      }
    }
  }

  choiceOptionCount(ci: number, option: MenuPackageItem): number {
    return this.pkgCounts[ci]?.[option.id] ?? 0;
  }

  choiceRemaining(ci: number): number {
    const choice = this.item.package!.choices![ci];
    return choice.count - Object.values(this.pkgCounts[ci]).reduce((acc, c) => acc + c, 0);
  }

  selectChoiceOption(ci: number, option: MenuPackageItem) {
    this.pkgCounts[ci] = {[option.id]: 1};
    this.updatePackageParts();
  }

  toggleChoiceVis(ci: number, option: MenuPackageItem) {
    if (this.blockUI) return;
    const key = this.visKeyFor('choice' + ci, '', option.id);
    if (this.visKey != null) {
      this.hideVis();
      return;
    }
    const c = this.choiceOptionCount(ci, option);
    if (c === 0 && this.choiceRemaining(ci) <= 0) {
      return;
    }
    this.visKey = key;
    if (c === 0) {
      this.changeChoiceCount(ci, option, 1);
    }
  }

  changeChoiceCount(ci: number, option: MenuPackageItem, delta: number) {
    if (delta > 0 && this.choiceRemaining(ci) <= 0) return;
    const next = Math.max(0, this.choiceOptionCount(ci, option) + delta);
    const counts = {...this.pkgCounts[ci]};
    if (next > 0) {
      counts[option.id] = next;
    } else {
      delete counts[option.id];
    }
    this.pkgCounts[ci] = counts;
    this.updatePackageParts();
    if (next === 0 || this.choiceRemaining(ci) === 0) {
      this.closeVisBriefly();
    }
  }

  choiceSurcharge(choice: MenuPackageChoice, option: MenuPackageItem): string | null {
    // An included push is free whatever is picked
    if (this.pick?.included) return null;
    const diff = (option.price ?? 0) - (choice.base ?? 0);
    // An option can cost less than the choice's base too
    if (diff > 0.004) return '+' + MoneyUtils.formatNoCents(diff);
    if (diff < -0.004) return '−' + MoneyUtils.formatNoCents(-diff);
    return null;
  }

  packageComplete(): boolean {
    return this.item.package == null || MenuUtils.isPackageSelectionComplete(this.item.package, this.pkgCounts, this.pkgParts);
  }

  closeDetail() {
    this.onClose.emit();
  }

  visibleAttributes() {
    return this.item?.attributes?.filter( atr => atr.hidden !== true ) ?? [];
  }

  hiddenAttributes() {
    return this.item.attributes?.filter( atr => atr.hidden === true ) ?? [];
  }

  getString(s: string, options?: string, lang?: string ) {
    if (lang === "sv") { return s; }   // source/venue language = no translation
    return this.translate.getString(s);
  }

  getPrice(item: MenuItem): string {
    if (this.pick?.included) {
      return '';
    }
    if (item.package != null && this.mode !== 'display' && !this.isTakeawayPrice(item)) {
      return MoneyUtils.formatNoCents(MenuUtils.packageSelectionPrice(item.package, this.pkgParts));
    }
    return this.orderService.getPriceForItem(item) || item.formatted;
  }

  getTakeawayPrice(item: MenuItem): string | null {
    return this.orderService.getTakeawayPriceForItem(item);
  }

  isTakeawayPrice(item: MenuItem): boolean {
    return this.orderService.isShowingTakeawayPrice(item);
  }

  private buildComment(lang: string|undefined): string | undefined {
    const strs: string[] = [];
    Object.keys(this.selCons).forEach( s => {
      const con = this.item.contains.find( it => it.id === s);
      if (con) {
        // removed_symbol_list.push(con.id);
        const info = con.info ? " (" + this.getString(con.info, "lower", lang) + ")" : "";
        const str = this.getString("utan", undefined, lang) + " " + this.getString(con.name, "lower", lang) + info;
        strs.push(str);
      }
    });
    Object.keys(this.selAdjs).forEach( s => {
      const adj = this.item.adjusts.find( it => it.id === s);
      if (adj) {
        const str = this.getString("utan", undefined, lang) + " " + this.getString(adj.name, "lower", lang);
        strs.push(str);
      }
    });

    return strs.length > 0 ? this.buildCommaAndStringFromList(strs, lang) : undefined;
  }

  private buildCommaAndStringFromList(strings: string[], lang?: string): string {
    if (strings.length > 2) {
      const last = strings.pop();
      const commaString = strings.join(", ");
      strings = [commaString, last!];
    }
    const value =  strings.join(` ${this.getString("och", undefined, lang)} `);
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  addNewItem() {
    const pas = new PostActions(this.item.post_actions);
    const giftcard = pas.getPostAction("giftcard");
    if (giftcard) {
      this.collectGiftCardInfo();
      return;
    }
    const comment = this.buildComment("sv");
    this.addItemNextStep(comment);
  }

  private addItemNextStep(comment?: string) {
    const fullItemId = MenuUtils.buildFullItemId(this.item, this.attrValues, this.item.package ? this.pkgParts : undefined);
    //console.log(`addItemNextStep: ${fullItemId}`);
    this.add(fullItemId, comment, true, this.postActionData, undefined);
  }

  // Edit mode: the new selection replaces one unit of the cart row. The new one is added first, so a failure leaves
  // the old one in the cart. same_as_rid gives the new row the old one's included push items, which go with the old.
  updateItem() {
    const old = this.editItem;
    if (old == null || !this.verifiyThatAttributesAreSelected() || !this.packageComplete()) return;
    const fullItemId = MenuUtils.buildFullItemId(this.item, this.attrValues, this.item.package ? this.pkgParts : undefined);
    // The server appends the comment hash (%%||) to the id; the comment stays the same
    if (fullItemId === MenuUtils.cleanItemId(old.id).split("%%||")[0]) {
      this.closeDetail();
      return;
    }
    this.isWorking = true;
    const uid = Math.random().toString(36).substring(7);
    this.orderService.addItemToOrder(fullItemId, old.comment || undefined, uid, undefined, old.rid).pipe(
      switchMap(() => this.orderService.removeItemFromOrder(old.id, true))
    ).subscribe({
      next: () => this.closeDetail(),
      error: (e) => {
        this.isWorking = false;
        this.snackbar.showMessageForError(e);
      },
      complete: () => {
        this.isWorking = false;
      }
    });
  }

  // Pick mode: hand the selection back to the push page or the cart's suggestions, which add it with the rest
  pickPackage() {
    if (this.pick == null || !this.verifiyThatAttributesAreSelected() || !this.packageComplete()) return;
    this.pick.done(MenuUtils.pickedPackage(this.item, this.attrValues, this.pkgParts));
    this.closeDetail();
  }

  // A part attribute's option shows only a relative surcharge, and nothing in an included push
  optionPriceShown(option: MenuItemOption, inPackage: boolean): boolean {
    if (!option.formatted) return false;
    if (!inPackage) return true;
    return !!option.price_diff && !this.pick?.included;
  }

  private addCopy() {
    // this.add(this.orderItem.id, undefined, false, undefined, this.orderItem.rid);
  }

  private add(fullItemId: string, comment: string|undefined, addNewItem: boolean, postActionData?: any, sameAsRid?: string) {
    if (!this.verifiyThatAttributesAreSelected() || !this.packageComplete()) return;
    this.isWorking = true;
    console.log(`onAdd: ${fullItemId} comment: ${comment}`);
    const uid = Math.random().toString(36).substring(7);
    if (this.itemCount === 1) {
      this.orderService.addItemToOrder(fullItemId, comment, uid, postActionData, sameAsRid).subscribe((order: Order) => {
          if (addNewItem) {
            const rid = order.add_item_result?.last_rid;
            this.postAddNew(rid);
          }
        },
        (e) => {
          // E.g. a prebook participant's part that is done: the server says why
          this.isWorking = false;
          this.snackbar.showMessageForError(e);
        },
        () => {
          this.isWorking = false;
        }
      );
    } else {
      // Add multiple items
      const itemIds = Array(this.itemCount).fill(fullItemId);
      this.orderService.addItemsToOrder(itemIds, undefined, false, false).subscribe((order: Order) => {
          if (addNewItem) {
            const rid = order.add_item_result?.last_rid;
            this.postAddNew(rid);
          }
        },
        (e) => {
          this.isWorking = false;
          this.snackbar.showMessageForError(e);
        },
        () => {
          this.isWorking = false;
        }
      );
    }

  }

  private postAddNew(rid?: string) {
    // Filter out pushes that have no available items
    this.item.pushes = this.item.pushes?.filter(push =>
      push.groups.some(group => this.menuService.getFilteredMenuItemsFromGroup(group).length > 0)
    );

    if (!MenuUtils.isDrink(this.item) && this.item.pushes?.length > 0) {
      const pp = {item: this.item, pushIndex: 0, rid} as PushPage
      this.sheetService.displayPushPage(pp);
    } else {
      this.closeDetail();
    }
  }

  /**
   * Calculate the price for a giftcard item
   * If there are attributes with price, use the first one's price
   * Otherwise use the item's base price
   */
  private calculateGiftcardPrice(): number {
    // If we have attributes, check if any selected option has a price
    if (this.item.attributes && this.item.attributes.length > 0) {
      for (const attr of this.item.attributes) {
        const attrValue = this.attrValues[attr.id];

        // For single-select attributes
        if (typeof attrValue === 'string') {
          const selectedOption = attr.options.find(opt => opt.key === attrValue);
          if (selectedOption && selectedOption.price) {
            // Return the first found option price
            return Number(selectedOption.price);
          }
        }
        // For multi-select attributes
        else if (typeof attrValue === 'object' && !Array.isArray(attrValue)) {
          for (const [optKey, count] of Object.entries(attrValue)) {
            if (Number(count) > 0) {
              const option = attr.options.find(opt => opt.key === optKey);
              if (option && option.price) {
                // Return the first found option price
                return Number(option.price);
              }
            }
          }

        }
      }
    }

    // If no attribute price found, use the item's base price
    return Number(this.item.price);
  }

  private collectGiftCardInfo() {
    console.log("collectGiftCardInfo");
    const amountInt = this.calculateGiftcardPrice();
    console.log(`Gift card amount: ${amountInt}`);
    console.log(`Gift card template: ${this.app.snapshot?.cfg.giftcard_template}`);

    const sheetData = {
      sender: localStorage.getItem("sender_name"),
      recipient: localStorage.getItem("receiver_name"),
      message: localStorage.getItem("message"),
      amount: amountInt,
      templateId: this.app.snapshot?.cfg.giftcard_template ?? "",
      callback: (result: GiftcardPersonalizedFormData) => {
        console.log(result);
        this.postActionData = [{
          "action": "giftcard",
          "sender_name": result.sender,
          "receiver_name": result.recipient,
          "message": result.message
        }];
        let comment = result.recipient;
        if (comment === "" || comment == null) {
          comment = undefined;
        }
        this.addItemNextStep(comment);
      }
    };
    this.sheetService.displaySheetClass("personalized-giftcard", "Presentkort", sheetData);
  }

  openTweaks() {
    this.tweaksOpen = !this.tweaksOpen;
  }

  // The attribute template serves the item's own attributes (scope '') and each package part's (scope = part key)
  private visKeyFor(scope: string, attributeId: string, optionKey: string) {
    return `${scope}|${attributeId}|${optionKey}`;
  }

  isVis(scope: string, attribute: MenuItemAttribute, option: MenuItemOption): boolean {
    return this.visKey === this.visKeyFor(scope, attribute.id, option.key);
  }

  toggleVis(values: AttrValues, scope: string, attribute: MenuItemAttribute, option: MenuItemOption) {
    if (this.blockUI) return;
    console.log(`toggleVis: ${attribute.id} ${option.key}`);
    if (this.visKey != null) {
      this.hideVis();
    } else {
      this.showVis(values, scope, attribute, option);
    }
  }

  hideVis() {
    this.visKey = undefined;
  }

  showVis(values: AttrValues, scope: string, attribute: MenuItemAttribute, option: MenuItemOption) {
    const c = this.getAttributeValue(values, attribute.id, option.key);
    const r = this.getRemainingSelectionCount(values, attribute);
    if (c === 0 && r === 0) {
      return;
    }
    this.visKey = this.visKeyFor(scope, attribute.id, option.key);
    if (c === 0) {
      // @ts-ignore
      values[attribute.id][option.key] = 1;
    }
  }

  getAttributeValue(values: AttrValues, attributeId: string, optionKey: string): number | undefined {
    const value = values[attributeId];
    if (typeof value === 'object' && !Array.isArray(value)) {
      return (value as Record<string, number>)[optionKey];
    }
    return undefined;
  }

  getTotalAttributeCount(values: AttrValues, attribute: MenuItemAttribute): number {
    if (attribute.multi) {
      const counts = values[attribute.id] as Record<string, number>;
      let total = 0;
      for (const key in counts) {
        total += counts[key];
      }
      return total;
    }
    return 0;
  }

  getRemainingSelectionCount(values: AttrValues, attribute: MenuItemAttribute): number {
    if (attribute.multi) {
      return attribute.multi.max - this.getTotalAttributeCount(values, attribute);
    }
    return 0;
  }

  onChangeAmount(values: AttrValues, attribute: MenuItemAttribute, option: MenuItemOption, count: number) {
    console.log(`onChangeAmount: ${attribute.id} ${option.key} ${count}`);
    const counts = values[attribute.id] as Record<string, number>;
    counts[option.key] += count;
    if (counts[option.key] === 0 || this.getRemainingSelectionCount(values, attribute) === 0) {
      this.closeVisBriefly();
    }
  }

  private closeVisBriefly() {
    this.visKey = undefined;
    //Since the UI is disappearing, we need to block accidental clicks for a short while
    this.blockUI = true;
    setTimeout(() => {
      this.blockUI = false;
    }, 400);
  }

  private verifiyThatAttributesAreSelected() {
    if (this.item.attributes) {
      for (const atr of this.item.attributes) {
        if (atr.multi) {
          const c = this.getTotalAttributeCount(this.attrValues, atr);
          if (c < atr.multi.min) {
            const message = this.getString("Välj minst") + " " + atr.multi.min + " " + atr.multi.unit;
            this.snackbar.showMessage(message);
            return false;
          }
        }
      }
    }
    return true;
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }
}

interface PackagePartView {
  part: PackagePart;
  attributes: MenuItemAttribute[];
  label: string;
}
